import { pick } from '@/lib/pick';
import type { MaybeArray } from '@/types/MaybeArray';

export const exclude = <T extends Record<string | symbol | number, any>, K extends keyof T>(obj: T, excluded: MaybeArray<K>): Omit<T, K> =>
  pick(
    obj,
    Object.keys(obj).filter((k) => (Array.isArray(excluded) ? !excluded.some((_excluded) => _excluded === k) : k !== excluded)) as Exclude<keyof T, K>[],
  );
